import React from "react";
import UnityGame from "~/components/UnityGame";

type GameEmbedProps = {
  buildPath: string;
  className?: string;
  style?: React.CSSProperties;
};

export default function GameEmbed({
  buildPath,
  className,
  style,
}: GameEmbedProps) {
  if (!buildPath) {
    return <p> Game unavailable.</p>;
  }
  return (
    <div
      className={"game-display-container-row " + (className ?? "")}
      style={style}
    >
      <UnityGame buildPath={buildPath} />
    </div>
  );
}
